import { createContext, useCallback, useContext, useRef } from 'react';
import { string as stringUtil } from '@eti/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const TranslationContext = /*#__PURE__*/createContext({
  translations: {},
  options: {}
});
const TranslationProvider = ({
  translations = {},
  options = {
    clearCache: false
  },
  children
}) => /*#__PURE__*/_jsx(TranslationContext.Provider, {
  value: {
    translations,
    options
  },
  children: children
});
const debugTextResolver = JSON.parse(sessionStorage.getItem('debugTextResolver') || '{}');
export const getTranslation = (key, translations, warnedKeys, overrideValue) => {
  const translation = overrideValue || key && translations[key];
  const wasWarned = typeof key === 'string' && warnedKeys.has(key);
  if (debugTextResolver.warnNotFoundKeys && !translation && !wasWarned) {
    // oxlint-disable-next-line no-console
    console.warn(`Translation not found for key: ${key}`);
    warnedKeys.add(key || '');
  }
  if (debugTextResolver.alwaysUseKeys || debugTextResolver.useKeyWhenTextNotFound && !translation) {
    return key !== null && key !== void 0 ? key : '';
  }
  return translation || '';
};
const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  const {
    translations
  } = context;
  const warnedKeys = useRef(new Set());
  const t = useCallback((key, ...params) => {
    return params.length === 0 ? getTranslation(key, translations, warnedKeys.current) : stringUtil.insertArgument(getTranslation(key, translations, warnedKeys.current), ...params);
  }, [translations]);
  const nonDebugT = useCallback((key, ...params) => {
    const translationKey = getTranslation(key, translations, warnedKeys.current);
    return params.length === 0 ? translationKey : stringUtil.insertArgument(translationKey, ...params);
  }, [translations]);
  const resolveTranslation = useCallback((key, overrideValue) => getTranslation(key, translations, warnedKeys.current, overrideValue), [translations]);
  return {
    t,
    nonDebugT,
    resolveTranslation
  };
};
export { TranslationProvider, useTranslation };
//# sourceMappingURL=TranslationContext.js.map